<template>
  <div>
    <changegeofence
      :addNewData="openModal"
      @closeModal="closeModal()"
      @changeModal="changeModal()"
      :dataEdit="dataEdit"
      :listGeofence="listGeofence"
      :title="titleModal"
      @submitModal="submitModal()"></changegeofence>
    <vs-row vs-w="12" v-if="render_ready">
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12">
        <vx-card>
          <template slot="no-body">
            <vs-button
              @click="changeGeofence()"
              class="mt-4 ml-2 shadow btn_map"
              type="gradient"
              color="#d23030"
              gradient-color-secondary="#f89595">
              <feather-icon
                color="green"
                icon="EditIcon"
                svgClasses="w-5 h-5"></feather-icon>
            </vs-button>
            <div class="heights_pairing">
              <GmapMap
                ref="mapRef"
                :center="center"
                :zoom="11"
                style="width: 100%; height: 100%"
                :options="{
                  zoomControl: false,
                  mapTypeControl: false,
                  scaleControl: false,
                  draggable: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUi: false,
                }">
                <GmapPolygon> </GmapPolygon>
              </GmapMap>
            </div>
          </template>
        </vx-card>
      </vs-col>
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12">
        <vx-card>
          <template slot="no-body">
            <div class="heights_pairing p-2">
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                <vs-row class="mt-5">
                  <vs-col vs-xs="12">
                    <div class="mb-1">{{ $t('Geofence Name') }}</div>
                    <vs-chip>
                      <vs-avatar icon-pack="feather" icon="icon-map" />
                      <span style="font-size: 18px">{{ name }}</span>
                    </vs-chip>
                  </vs-col>
                </vs-row>

                <vs-row class="mt-5">
                  <vs-col vs-xs="12">
                    <div class="mb-1">{{ $t('Geofence Type') }}</div>
                    <vs-chip>
                      <vs-avatar icon-pack="feather" icon="icon-cloud" />
                      <span style="font-size: 18px">{{ type }}</span>
                    </vs-chip>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-5">
                  <vs-col vs-xs="12">
                    <ul class="centerx">
                      <li>
                        <vs-checkbox v-model="alert_in_zone">{{
                          $t('Alert In Zone')
                        }}</vs-checkbox>
                      </li>
                      <li>
                        <vs-checkbox v-model="alert_out_zone">{{
                          $t('Alert Out Zone')
                        }}</vs-checkbox>
                      </li>
                      <li class="flex flex-row items-center">
                        <vs-checkbox v-model="geofence_dc_active">{{
                          $t('Geofence DC Active')
                        }}</vs-checkbox>
                        <span>
                          <vs-tooltip
                            color="#4F4F4F"
                            :text="'Khusus untuk DC ketika unit di luar area ini akan dianggap sebagai Unit in Operation'"
                            position="bottom">
                            <feather-icon
                              icon="HelpCircleIcon"
                              class="cursor-pointer"
                              style="
                                width: 15px;
                                height: 15px;
                                color: #616161;
                              "></feather-icon>
                          </vs-tooltip>
                        </span>
                      </li>
                    </ul>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                <!-- <div class="mb-1 mt-5">Options</div> -->
                <div class="flex flex-col mt-5 mb-2">
                  <label for="">{{ $t('Overspeed Threshold') }}</label>
                  <div class="flex flex-row items-center" style="gap: 5px">
                    <input
                      type="number"
                      v-model="overspeed_threshold"
                      class="mt-1 mb-1 vs-inputx vs-input--input normal"
                      style="width: 200px"
                      placeholder="Overspeed Threshold" />
                    km/h
                    <vs-tooltip
                      color="#4F4F4F"
                      :text="'Kecepatan maksimal kendaraan pada geofence ini'"
                      position="bottom">
                      <feather-icon
                        icon="HelpCircleIcon"
                        class="cursor-pointer"
                        style="
                          width: 15px;
                          height: 15px;
                          color: #616161;
                        "></feather-icon>
                    </vs-tooltip>
                  </div>
                </div>
                <div class="flex flex-col mb-2">
                  <label for="">{{ $t('Overstay Engine On Threshold') }}</label>
                  <div class="flex flex-row items-center" style="gap: 5px">
                    <input
                      type="number"
                      v-model="overstay_threshold"
                      class="mt-1 mb-1 vs-inputx vs-input--input normal"
                      style="width: 200px"
                      placeholder="Overstay Threshold" />
                    {{ $t('minutes') }}
                    <vs-tooltip
                      color="#4F4F4F"
                      :text="'Durasi maksimal kendaraan diam pada geofence ini'"
                      position="bottom">
                      <feather-icon
                        icon="HelpCircleIcon"
                        class="cursor-pointer"
                        style="
                          width: 15px;
                          height: 15px;
                          color: #616161;
                        "></feather-icon>
                    </vs-tooltip>
                  </div>
                </div>
                <div class="flex flex-col mb-2">
                  <label for="">{{
                    $t('Overstay Engine Off Threshold')
                  }}</label>
                  <div class="flex flex-row items-center" style="gap: 5px">
                    <input
                      type="number"
                      v-model="parking_threshold"
                      class="mt-1 mb-1 vs-inputx vs-input--input normal"
                      style="width: 200px"
                      placeholder="Parking Threshold" />
                    {{ $t('minutes') }}
                    <vs-tooltip
                      color="#4F4F4F"
                      :text="'Durasi maksimal kendaraan parkir pada geofence ini'"
                      position="bottom">
                      <feather-icon
                        icon="HelpCircleIcon"
                        class="cursor-pointer"
                        style="
                          width: 15px;
                          height: 15px;
                          color: #616161;
                        "></feather-icon>
                    </vs-tooltip>
                  </div>
                </div>
              </vs-col>
              <div class="row">
                <vs-button
                  style="position: absolute; right: 11px; bottom: 9px"
                  @click="submit"
                  class="mt-4 ml-2 shadow"
                  type="gradient"
                  color="#d23030"
                  gradient-color-secondary="#f89595"
                  >Submit
                </vs-button>
              </div>
            </div>
          </template>
        </vx-card>
      </vs-col>
    </vs-row>
    <vs-divider style="margin: 7px 0"></vs-divider>
    <vs-row vs-w="12">
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12">
        <vx-card>
          <template slot="no-body">
            <vs-row vs-w="12" style="border-bottom: 1px solid #ded8d8">
              <vs-col
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-xs="12">
                <div
                  class="vs-component vs-con-input-label vs-input mt-1 mb-1 vs-input-primary">
                  <!--<label class="vs-input--label">Type</label>-->
                  <v-select
                    placeholder="- Select Fleet Group -"
                    style="background: white"
                    @input="(x) => (selectedFleet = x)"
                    :clearable="false"
                    :value="getSelectValue(selectedFleet, fleet_array)"
                    :reduce="(text) => text.value"
                    label="text"
                    :options="fleet_array" />
                </div>
                <!--<vs-select autocomplete v-model="selectedFleet" placeholder="- Select Fleet Group -" class="mt-1 mb-1">-->
                <!--<vs-select-item :key="item.value" :value="item" :text="item.text" v-for="item in fleet_array" />-->
                <!--</vs-select>-->
              </vs-col>
              <vs-col
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-xs="12">
                <input
                  type="text"
                  v-model="searchA"
                  class="mt-1 mb-1 vs-inputx vs-input--input normal"
                  placeholder="Search.." />
              </vs-col>
            </vs-row>
            <vs-list class="height-scroll">
              <!--<draggable :list="listVehicle" group="people" class="p-2 cursor-move">-->
              <vs-list-item
                @click="addThis(listItem)"
                v-for="(listItem, index) in filteredListA()"
                :key="index"
                :title="listItem.license_plate"
                :subtitle="selectedFleet.origin">
                <!--<vs-avatar slot="avatar" :text="listItem.name" @click="addThis(listItem)"/>-->
                <template slot="avatar">
                  <span class="icon-container">
                    <feather-icon
                      color="green"
                      icon="ChevronRightIcon"
                      svgClasses="w-4 h-4"
                      @click="addThis(listItem)"></feather-icon>
                  </span>
                </template>
                <div
                  class="vs-list--slot cursor"
                  style="color: green"
                  @click="addThis(listItem)">
                  <span>
                    <feather-icon
                      color="green"
                      icon="PlusIcon"
                      svgClasses="w-8 h-8"></feather-icon>
                  </span>
                </div>
              </vs-list-item>
              <!--</draggable>-->
            </vs-list>
          </template>
        </vx-card>
      </vs-col>
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12">
        <vx-card>
          <template slot="no-body">
            <vs-row vs-w="12" style="border-bottom: 1px solid #ded8d8">
              <vs-col
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-xs="12">
                <h5 class="mt-3">{{ $t('Paired Vehicle') }}</h5>
              </vs-col>
              <vs-col
                vs-justify="center"
                vs-align="center"
                vs-lg="6"
                vs-sm="6"
                vs-xs="12">
                <input
                  type="text"
                  v-model="searchB"
                  class="mt-1 mb-1 vs-inputx vs-input--input normal"
                  placeholder="Search.." />
              </vs-col>
            </vs-row>
            <!--<input type="text" v-model="searchB" class="vs-inputx vs-input&#45;&#45;input normal custom-search" placeholder="Search..">-->
            <vs-list class="height-scroll">
              <!--<draggable :list="listPaired" group="people" class="p-2 cursor-move">-->
              <vs-list-item
                @click="removeThis(listItem)"
                v-for="(listItem, index) in filteredListB()"
                :key="index"
                :title="listItem.license_plate"
                :subtitle="listItem.fleet_group_name">
                <!--<vs-avatar @click="removeThis(listItem)" slot="avatar" text="listItem.name" />-->
                <template slot="avatar">
                  <span class="icon-container">
                    <feather-icon
                      color="green"
                      icon="ChevronRightIcon"
                      svgClasses="w-4 h-4"
                      @click="removeThis(listItem)"></feather-icon>
                  </span>
                </template>
                <div
                  class="vs-list--slot cursor"
                  style="color: red"
                  @click="removeThis(listItem)">
                  <span>
                    <feather-icon
                      color="green"
                      icon="XIcon"
                      svgClasses="w-8 h-8"></feather-icon>
                  </span>
                </div>
              </vs-list-item>
              <!--</draggable>-->
            </vs-list>
          </template>
        </vx-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import draggable from 'vuedraggable'
import * as REPO from '../../../repository/index'
import changegeofence from './MappingChangeGeofence.vue'

export default {
  components: {
    draggable,
    changegeofence,
  },
  props: {
    geoName: String,
    geoType: String,
  },
  watch: {
    selectedFleet(val) {
      if (val !== '') {
        REPO.getListVehicleFleetGroup(val.value).then((res) => {
          //
          //
          let tmp = res.data.data.filter((x) => {
            let tmp2 = this.listPaired.filter((y) => {
              return y.vehicle_id == x.id
            })
            return tmp2.length === 0
          })
          tmp.forEach((z) => {
            z.fleet_group_name = this.selectedFleet.text
          })
          this.listVehicle = tmp
          this.listVehicleOriginal = res.data.data
        })
      } else {
        this.listVehicle = []
      }

      // (val);
    },
  },
  computed: {
    dataCoordinateLocal: {
      get() {
        // ("List Coordinate");
        // (this.dataCoordinate);

        return JSON.parse(this.dataCoordinate)
      },
      set(val) {
        if (!val) {
          // (val);
          this.$emit('closeModal')
        }
      },
    },
    google: gmapApi,
  },
  mounted() {
    // var self = this;
    this.getData()
    this.$refs.mapRef.$mapPromise.then((map) => {
      google.maps.Polygon.prototype.getBounds = function () {
        var bounds = new google.maps.LatLngBounds()
        var paths = this.getPaths()
        var path
        for (var i = 0; i < paths.getLength(); i++) {
          path = paths.getAt(i)
          for (var ii = 0; ii < path.getLength(); ii++) {
            bounds.extend(path.getAt(ii))
          }
        }
        return bounds
      }
    })
    setTimeout(() => {
      this.getPolygon()
    }, 300)
  },
  data() {
    return {
      fleet_array: [],
      overlays: [],
      id: '',
      name: '',
      type: '',
      titleModal: '',
      dataEdit: {},
      searchA: '',
      openModal: false,
      render_ready: true,
      selectedFleet: '',
      searchB: '',
      colour: '',
      data_coordinate: [],
      dataCoordinate: [],
      listGeofence: [],
      listFleet: [],
      listVehicleOriginal: [],
      listVehicle: [],
      listPaired: [],
      listPairedOriginal: [],
      drawingManager: '',
      alert_out_zone: false,
      alert_in_zone: false,
      geofence_dc_active: false,

      overspeed_threshold: 0,
      overstay_threshold: 0,
      parking_threshold: 0,

      selectedShape: '',
      selectedColor: '',
      colorButtons: {},
      colors: ['#1E90FF', '#FF1493', '#32CD32', '#FF8C00', '#4B0082'],
      center: { lat: -6.1498619, lng: 106.882887 },
    }
  },
  methods: {
    rekursive(arr, res, counter) {
      arr.forEach((x) => {
        let text = ''
        if (counter > 0) {
          for (let z = 0; z < counter; z++) {
            text = text + '- '
          }
        }
        text = text + (parseInt(counter) + 1) + ' ' + x.fleet_group_name
        let tmp = {
          text: text,
          origin: x.fleet_group_name,
          value: x.id,
        }

        res.push(tmp)
        if (x.all_child.length > 0) {
          let con = counter + 1
          this.rekursive(x.all_child, res, con)
        }
      })
    },
    changeModal() {
      this.render_ready = false
      this.$nextTick().then(() => {
        this.selectedFleet = ''
        this.render_ready = true
        // ("Change modal");
        this.openModal = false
        this.getData()
        this.getPolygon()
        this.$forceUpdate()
      })
    },
    changeGeofence() {
      this.titleModal = 'Change Geofence'
      this.openModal = true
    },
    submit() {
      this.$vs.loading()
      var self = this
      let list_paired_v = []
      self.listPaired.forEach((z) => {
        list_paired_v.push({
          alert_in_zone: this.alert_in_zone ? '1' : '0',
          alert_out_zone: this.alert_out_zone ? '1' : '0',
          geofence_dc_active: this.geofence_dc_active ? '1' : '0',
          // overspeed: parseInt(this.overspeed_threshold),
          // overstay_engine_on: parseInt(this.overstay_threshold),
          // overstay_engine_off: parseInt(this.parking_threshold),
          fleet_group_id: z.fleet_group_id,
          license_plate: z.license_plate,
          fleet_group_name: z.fleet_group_name,
          reff_vehicle_id: '',
          imei_obd_number: z.imei_obd_number,
          vin: z.vin,
          vehicle_id: z.vehicle_id,
        })
      })
      let data_detail = {
        geofence_id: this.id,
        created_by: self.$dataLocal.UserData().name,
        data_vehicle: list_paired_v,
        overspeed: parseInt(this.overspeed_threshold),
        overstay_engine_on: parseInt(this.overstay_threshold),
        overstay_engine_off: parseInt(this.parking_threshold),
      }
      REPO.updateGeofencePairing(data_detail, this.id)
        .then((res2) => {
          this.$vs.loading.close()
          if (res2.data.status == 'true') {
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
            // setTimeout(()=>{
            //     this.$router.push('/master-data/geofence')
            // })
          } else {
            this.$toast.error(res2.data.error_msg)
          }
        })
        .catch((err2) => {
          this.$vs.loading.close()
          // (err2);
          self.$vs.notify({
            time: 2500,
            title: 'Error',
            text: err2.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          })
        })
    },
    getData() {
      var self = this
      this.$vs.loading()
      this.id = this.$route.params.id
      REPO.getListGeofence().then((res) => {
        this.listGeofence = res.data.data
      })
      this.fleet_array = [
        {
          text: 'All',
          value: this.$dataLocal.UserData().id,
        },
      ]
      REPO.getListFleetChield(this.$dataLocal.UserData().id).then((res) => {
        if (res.data.status == 'true') {
          let tmp = res.data.data.map((h) => {
            return {
              text: h.fleet_group_name,
              value: h.id,
            }
          })
          // let hasil = []
          // this.rekursive(tmp, hasil, 0)

          //
          this.overspeed_threshold = tmp[0].overspeed
          this.overstay_threshold = tmp[0].overstay_engine_on
          this.parking_threshold = tmp[0].overstay_engine_off

          this.fleet_array = [...this.fleet_array, ...tmp]
          REPO.getListVehicleGeofence(this.id).then((res) => {
            let paired = res.data.data

            paired = res.data.data
            if (paired.length > 0) {
              let tmp = paired[0].geofence.filter((x) => {
                return x.geofence_id == this.id
              })

              if (tmp[0].alert_in_zone == '1') {
                this.alert_in_zone = true
              } else {
                this.alert_in_zone = false
              }
              if (tmp[0].alert_out_zone == '1') {
                this.alert_out_zone = true
              } else {
                this.alert_out_zone = false
              }
              if (tmp[0].geofence_dc_active == '1') {
                this.geofence_dc_active = true
              } else {
                this.geofence_dc_active = false
              }
            } else {
              this.alert_in_zone = false
              this.alert_out_zone = false
            }
            // paired.forEach(x=>{
            //     let tmp = this.fleet_array.filter(y=>{
            //         return x.fleet_group_id == y.value;
            //     });
            //     if(tmp.length>0){
            //         x.fleet_group_name = tmp.text;
            //     }else{
            //         x.fleet_group_name = x.fleet_group_id;
            //     }
            // });
            self.$vs.loading.close()
            this.listPaired = []
            paired.forEach((o) => {
              this.listPaired.push({
                fleet_group_id: o.fleet_group_id,
                reff_vehicle_id: o.reff_vehicle_id,
                fleet_group_name: o.fleet_group_name,
                imei_obd_number: o.imei_obd_number,
                vin: o.vin,
                vehicle_id: o.vehicle_id,
                license_plate: o.license_plate,
              })
            })
            // (this.listPaired)
          })
        }
      })
      // REPO.getListFleetGroup().then(res=>{
      //     this.listFleet= res.data.data;
      //     this.fleet_array=[]
      //     this.listFleet.forEach(x=>{
      //         this.fleet_array.push({
      //             text:x.fleet_group_name,
      //             value:x.id
      //         })
      //     })
      //
      // }) ;
    },
    filteredListA() {
      if (this.searchA.length > 0) {
        return this.listVehicle.filter((post) => {
          return post.license_plate
            .toLowerCase()
            .includes(this.searchA.toLowerCase())
        })
      } else {
        return this.listVehicle
      }
    },
    filteredListB() {
      if (this.searchB.length > 0) {
        return this.listPaired.filter((post) => {
          return post.license_plate
            .toLowerCase()
            .includes(this.searchB.toLowerCase())
        })
      } else {
        return this.listPaired
      }
    },
    removeA(arr, key, val) {
      return arr.filter(function (obj) {
        return obj[key] !== val
      })
    },
    addThis(val) {
      // ("add ", val)
      this.listVehicle = this.removeA(
        this.listVehicle,
        'license_plate',
        val.license_plate
      )

      this.listPaired.push({
        vehicle_id: val.id,
        fleet_group_id: val.fleet_group_id,
        reff_vehicle_id: val.reff_vehicle_id,
        fleet_group_name: this.selectedFleet.origin,
        imei_obd_number: val.imei_obd_number,
        vin: val.vin,
        license_plate: val.license_plate,
      })
    },
    removeThis(val) {
      // ("remove ", val.name);
      this.listPaired = this.removeA(
        this.listPaired,
        'license_plate',
        val.license_plate
      )
      let tmp = this.listVehicleOriginal.filter((x) => {
        return x.id == val.vehicle_id
      })
      if (tmp.length > 0) {
        this.listVehicle.push({
          reff_vehicle_id: val.reff_vehicle_id,
          imei_obd_number: val.imei_obd_number,
          fleet_group_name: val.fleet_group_name,
          origin: val.fleet_group_name,
          vin: val.vin,
          id: val.vehicle_id,
          fleet_group_id: val.fleet_group_id,
          license_plate: val.license_plate,
        })
      }
    },
    getPolygon() {
      this.id = this.$route.params.id
      var self = this
      REPO.getOneGeofence(this.id).then((res_geo) => {
        this.name = res_geo.data.data.geofence_name
        this.type = res_geo.data.data.type
        this.colour = res_geo.data.data.colour
        // REPO.getGeofenceDetail(this.id).then(res => {
        this.dataCoordinate = res_geo.data.data.geofence_detail.coordinates[0]
        this.$refs.mapRef.$mapPromise.then((map) => {
          var poly = []
          if (this.drawingManager !== '') this.drawingManager.setMap(null)
          this.dataCoordinate.forEach((x) => {
            let tmp = new google.maps.LatLng(x['1'], x['0'])
            poly.push(tmp)
          })
          let color = '#FF0000'
          if (this.colour != '') {
            color = this.colour
          }
          this.drawingManager = new google.maps.Polygon({
            path: poly,
            draggable: false,
            editable: false,
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: color,
            fillOpacity: 0.35,
            map: map,
          })
          // ("center");
          map.fitBounds(this.drawingManager.getBounds())
        })
        // })
      })
    },
    closeModal() {
      this.openModal = false
    },
    editGeo() {
      this.$emit('editGeo', 'someValue')
      setTimeout(() => {
        this.$router.push(
          '/master-data/geofence-detail-update/' + this.dataEdit.id
        )
      }, 500)
    },
  },
}
</script>
<style lang="scss">
.heights_pairing {
  min-height: 278px;
  height: calc(100vh - 39.1rem);
}
</style>
<style scoped>
.custom-search {
  position: absolute;
  width: 50%;
  right: 7px;
  top: 2px;
  z-index: 3;
}

.cursor {
  cursor: pointer;
}

.height-scroll {
  height: calc(100vh - 37.1rem);
  overflow: auto;
}

.btn_map {
  z-index: 3;
  position: absolute;
  background: linear-gradient(
    30deg,
    rgb(115, 103, 240) 0%,
    rgb(206, 159, 252) 100%
  );
  top: 0;
  right: 14px;
  padding: 9px 18px !important;
}

.icon-container {
  width: 37px;
  text-align: center;
  height: 37px;
  padding-top: 10px;
  margin-right: 10px;
}
</style>
